import { useContext, useLayoutEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { AppContext } from '../../../contextApi/ContextApi';
import { ClientContext } from '../../../contextApi/ClientContext';

export default function ProductComponent_content({website, val, isDashboard, setDisplay}) {
    const {accent_color, primary_color, secondary_color, connected, fetchImage, setToastMessage, messagesOptions} = useContext(AppContext);
    const { moveToProductPage, increaseAmount, isUpdatingCart} = useContext(ClientContext);
    const nav = useNavigate();
    const params = useParams();
    const discountCalc = parseFloat(val.price/100) * (100-val.disValue);
    const [isHoverBtn, setIsHoverBtn] =useState(false);
    const [hasAStock, setHasAStock] = useState(val?.hasAmount);
    const [hasInStock, setHasInStock] = useState(val?.amount>0);
    
    const [imgURL, setImgURL] = useState("");
    useLayoutEffect(()=>{
        setHasAStock(val?.hasAmount);
        setHasInStock(val?.amount>0);
        fetchImage(website, val, setImgURL);
    },[val])

    return (
        <div className='productComp_subContainer' dir='rtl'>
            <div className='productComp_logoDiv'>
                <img onClick={()=>{moveToProductPage(nav, website, params, val, setToastMessage, messagesOptions, isDashboard, setDisplay)}} className='productComp_logo' src={imgURL} alt="product_image"/>
                {hasAStock&&!hasInStock && <div className='productComp_logo_outOfStock'>המלאי אזל</div>}
            </div>
            <div className='productComp_name'>{val.name}</div>
            <p className='productComp_price'>
                <span>מחיר: </span>{val.hasDiscount ? (
                    <>
                        {discountCalc.toFixed(2)}₪{" "}
                        <span style={{ textDecoration: "line-through", opacity: 0.7 }}>
                            {val.price}₪
                        </span>
                    </>
                ) : (<>{discountCalc.toFixed(2)}₪</>)}
            </p>
            
            {connected && (hasAStock&&hasInStock|| !hasAStock) && <button disabled={isUpdatingCart} onMouseEnter={()=>{setIsHoverBtn(true)}} onMouseLeave={()=>{setIsHoverBtn(false)}} className='productComp_cartBtn' style={{backgroundColor:isHoverBtn ? secondary_color : accent_color, color: isHoverBtn? accent_color : primary_color, border:`0.5px solid ${isHoverBtn ? accent_color : primary_color}`, fontSize:"18px"}} onClick={()=>{connected&&!isDashboard ? increaseAmount(website, val, setToastMessage, messagesOptions, true) : isDashboard ? alert("לחצן זה יוסיף את המוצר לעגלה בתנאי שהלקוח רשום כמנוי") : alert("עליך להיות מחובר על מנת לבצע רכישה")}}>{isUpdatingCart ? null : <span>🛒</span>}{isUpdatingCart ? "המתן.." : "הוסף לעגלה"}</button>}
        </div>
    )
}
